function MenuItem({ label, icon, isSelected, onSelect, isCollapsed, disabled = false }) {
    const handleClick = () => {
      if (!disabled) onSelect(label);
    };
  
    return (
        <div
            className={`menu-item ${isSelected ? 'menu-item-selected' : ''} ${isCollapsed ? 'collapsed' : ''} ${disabled ? 'menu-item-disabled' : ''}`}
            onClick={handleClick}
            aria-disabled={disabled || undefined}
            title={isCollapsed ? label : ''}
        >
          <img src={icon} alt={`${label} icon`} className="menu-item-icon" />
          {!isCollapsed && <span className="menu-item-label">{label}</span>}
        </div>
    );
  }

  export default MenuItem; 
